// 루트 파인더 프로필 (큐레이션). 합격선 숫자 금지. 최종은 모집요항 원문.
import { examplesForIds } from './programExamples';
import { officialResources } from './officialResources';

const STAGE_ORDER = ['explore', 'prep', 'apply'];

const commonDisclaimer =
  '안내는 참고용입니다. 지원 자격·과목·일정은 해당 연도 대학·기관 모집요항 원문으로 확인하세요.';

export const routeProfiles = [
  {
    id: 'eju-stem',
    tracks: ['eju'],
    fields: ['stem'],
    stages: ['explore', 'prep', 'apply'],
    title: 'EJU → 이공·정보',
    summary:
      '일본어·수학(대개 코스2)·이과 과목을 축으로 국립·공립·사립 유학생 전형을 맞추는 루트입니다.',
    facts: {
      needsEju: true,
      ejuSubjectsHint: '일본어 + 수학(코스2 많음) + 이과(물리·화학 등)',
      mathCourseHint: '코스2 비중 높음 — 요강 지정 확인',
      englishExternal: 'often',
      hasPreArrivalHint: 'possible',
      usesKyotsu: false,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        'EJU 과목·수학 코스·이과 조합이 지망 학부에 맞는지 훑기',
        '관심 대학 입시 페이지 3곳을 북마크',
        '2026 EJU 기초학력 시라버스 변경 여부 확인',
      ],
      prep: [
        '목표 대학 요강 3곳에서 EJU 지정회·출제언어 표 만들기',
        '영어 외부시험 종류·유효기간·직송 여부 정리',
        '요강 체크리스트로 서류·필착 마감 연습',
      ],
      apply: [
        '해당 연도 PDF로 출원자격·검정료·면접일을 재대조',
        '성적 통지·출원 일정 역산',
        '비자·입학 수속 안내가 요강 밖인지 확인',
      ],
    },
    guideIds: ['eju-vs-general', 'eju-2026-syllabus', 'science-medicine-path', 'yokoan-howto', 'english-in-yokoan', 'prearrival-scholarship', 'example-national-stem'],
    resourceIds: [
      'jasso-eju',
      'jasso-eju-syllabus-2026',
      'jasso-prearrival-schools',
      'jasso-scholarship-honors',
      'studyinjapan-home',
      'hokudai-intl',
      'tohoku-intl',
      'tus-intl',
      'immigration-studyinjapan',
    ],
    exampleIds: [
      'hokudai-stem',
      'titech-stem',
      'osaka-stem',
      'waseda-stem',
      'tohoku-stem',
      'tus-stem',
    ],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'eju-medicine',
    tracks: ['eju'],
    fields: ['medicine'],
    stages: ['explore', 'prep', 'apply'],
    title: 'EJU → 의치약·보건(유학생)',
    summary:
      '모집 규모가 작고 전형 변동이 잦습니다. 유학생 특별전형 실시 여부부터 요강으로 확인하세요.',
    facts: {
      needsEju: true,
      ejuSubjectsHint: '일본어 + 수학 + 이과(조합은 학부마다 상이)',
      mathCourseHint: '요강 지정(코스1/2) 필수 확인',
      englishExternal: 'often',
      hasPreArrivalHint: 'rare',
      usesKyotsu: false,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        '유학생 특별전형으로 의계를 받는 대학이 있는지 입시 페이지부터 조사',
        '일반선발만 허용인 학부와 구분',
        '이공 루트와 병행할지 기준 정하기',
      ],
      prep: [
        '지원 가능 대학 리스트 + 요강 PDF 링크 표',
        '수학·이과·면접·서류 비중을 원문에서 체크',
        '영어 성적 최저·제출 방식 확인',
      ],
      apply: [
        '해당 연도 요강으로 자격·회차·시험일을 최종 확정',
        '면접·소논문 유무와 준비물 점검',
        '복수 지원 시 일정 충돌 없는지 확인',
      ],
    },
    guideIds: ['science-medicine-path', 'yokoan-howto', 'english-in-yokoan', 'eju-2026-syllabus', 'example-medicine-track', 'mext-to-medicine'],
    resourceIds: [
      'jasso-eju',
      'jasso-eju-syllabus-2026',
      'u-tokyo-intl',
      'kyoto-intl',
      'sapmed-intl',
      'immigration-studyinjapan',
    ],
    exampleIds: ['utokyo-med', 'kyoto-med', 'hokudai-med', 'osaka-med', 'okayama-med', 'sapmed-med'],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'eju-humanities',
    tracks: ['eju'],
    fields: ['humanities'],
    stages: ['explore', 'prep', 'apply'],
    title: 'EJU → 문과·사회',
    summary:
      '종합과목·일본어 배점이 큰 경우가 많습니다. 대학별 영어 외부시험 요구를 표로 정리하세요.',
    facts: {
      needsEju: true,
      ejuSubjectsHint: '일본어 + 종합과목(+ 수학 코스1 등 요강 지정)',
      mathCourseHint: '코스1 또는 면제 — 요강 확인',
      englishExternal: 'often',
      hasPreArrivalHint: 'possible',
      usesKyotsu: false,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        '종합과목 vs 이과 루트 중 어디에 맞는지 정하기',
        '관심 학부 3곳의 유학생 전형 페이지 북마크',
        '영어 시험 종류를 미리 조사',
      ],
      prep: [
        'EJU 지정회·출제언어·종합과목 범위를 요강에서 대조',
        '영어 성적 제출·직송 요건 정리',
        '소논문·면접 유무 체크',
      ],
      apply: [
        '원서·필착·검정료를 해당 연도 PDF로 재확인',
        '서류(번역·공증) 형식 점검',
        '합격 후 비자 안내 위치 확인',
      ],
    },
    guideIds: ['eju-vs-general', 'yokoan-howto', 'english-in-yokoan', 'prearrival-scholarship', 'example-private-hum'],
    resourceIds: [
      'jasso-eju',
      'jasso-eju-syllabus-2026',
      'jasso-prearrival-schools',
      'studyinjapan-home',
      'u-tokyo-intl',
      'hit-intl',
      'keio-intl',
    ],
    exampleIds: ['utokyo-hum', 'keio-hum', 'sophia-hum', 'hit-hum', 'rikkyo-hum', 'icu-hum'],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'general-stem',
    tracks: ['general'],
    fields: ['stem'],
    stages: ['explore', 'prep', 'apply'],
    title: '일반입시 → 이공·정보',
    summary:
      '공통테스트와 대학별 본고사(개별학력검사)가 중심입니다. 일본 고교 과정에 가까운 준비가 필요합니다.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '필수 아님(대학이 별도 인정하는 경우만)',
      mathCourseHint: '본고사·공통테스트 수학 범위',
      englishExternal: 'varies',
      hasPreArrivalHint: 'rare',
      usesKyotsu: true,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        '공통테스트 과목 설계 vs EJU 유학생 전형 중 선택 기준 정리',
        '국립/사립 일반선발 요강 샘플 2~3개 열기',
        '출원자격(학력·일본어) 문구 확인',
      ],
      prep: [
        '공통테스트 과목·일정 확정 (DNC 공식)',
        '본고사 과목 매트릭스(대학별)',
        '과거 문제·조사서 입수 경로',
      ],
      apply: [
        'Web 출원·검정료·조사서 마감 역산',
        '본고사 당일 준비물·시험장 확인',
        '복수 지원 일정 충돌 점검',
      ],
    },
    guideIds: ['eju-vs-general', 'yokoan-howto'],
    resourceIds: ['dnc-kyotsu', 'dnc-web-apply', 'hokudai-intl', 'kyushu-intl', 'nagoya-intl'],
    exampleIds: [
      'dnc-general-stem',
      'hokudai-general-stem',
      'kyushu-general-stem',
      'nagoya-general-stem',
      'tsukuba-general-stem',
    ],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'general-medicine',
    tracks: ['general'],
    fields: ['medicine'],
    stages: ['explore', 'prep', 'apply'],
    title: '일반입시 → 의치약·보건',
    summary:
      '공통테스트·본고사 비중이 크고 경쟁이 치열합니다. 유학생 특별전형과 혼동하지 마세요.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '일반선발에서는 통상 미사용',
      mathCourseHint: '공통테스트·본고사 수학/이과',
      englishExternal: 'varies',
      hasPreArrivalHint: 'rare',
      usesKyotsu: true,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        '일반선발만 받는 의계와 유학생 전형 가능 대학을 구분',
        '공통테스트 과목 부담을 현실적으로 가늠',
        '출원자격·일본어 전제 확인',
      ],
      prep: [
        '공통테스트·본고사 범위 표 작성',
        '면접·서류 비중 확인',
        '원서·조사서 일정 캘린더',
      ],
      apply: [
        '해당 연도 요강으로 과목·배점·일정을 최종 확정',
        '출원 서류·사진·검정료 점검',
        '예비일·추가모집 유무 확인',
      ],
    },
    guideIds: ['science-medicine-path', 'mext-to-medicine', 'eju-vs-general', 'yokoan-howto'],
    resourceIds: ['dnc-kyotsu', 'dnc-web-apply', 'u-tokyo-intl', 'kyoto-intl', 'sapmed-intl'],
    exampleIds: [
      'utokyo-general-med',
      'kyoto-general-med',
      'sapmed-general-med',
      'kumamoto-general-med',
      'dnc-general-stem',
    ],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'general-humanities',
    tracks: ['general'],
    fields: ['humanities'],
    stages: ['explore', 'prep', 'apply'],
    title: '일반입시 → 문과·사회',
    summary:
      '공통테스트와 대학별 2차(본고사·면접·서류)를 조합합니다. EJU 문과 전형과 과목 설계가 다릅니다.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '일반선발에서는 통상 미사용',
      mathCourseHint: '공통테스트 수학 필요 여부 요강 확인',
      englishExternal: 'varies',
      hasPreArrivalHint: 'rare',
      usesKyotsu: true,
      mextPath: false,
    },
    nextStepsByStage: {
      explore: [
        'EJU 문과 vs 일반선발 문과 중 어디에 맞는지 비교',
        '관심 대학 일반선발 요강 샘플 열기',
        '출원자격 확인',
      ],
      prep: [
        '공통테스트 과목 확정',
        '2차 과목·소논문·면접 유무 정리',
        '조사서·서류 일정',
      ],
      apply: [
        '필착·Web 출원 마감 재확인',
        '시험장·준비물',
        '복수 지원 일정',
      ],
    },
    guideIds: ['eju-vs-general', 'yokoan-howto'],
    resourceIds: ['dnc-kyotsu', 'dnc-web-apply', 'kyoto-intl', 'hit-intl', 'meiji-intl'],
    exampleIds: [
      'kyoto-general-hum',
      'hit-general-hum',
      'meiji-general-hum',
      'aoyama-general-hum',
      'dnc-general-stem',
    ],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'mext-stem',
    tracks: ['mext'],
    fields: ['stem'],
    stages: ['explore', 'prep', 'apply'],
    title: '국비(MEXT) → 이공·정보',
    summary:
      '대사관 추천·대학 추천 일정이 사비 EJU/일반입시와 겹칩니다. 국비만 의존하지 말고 병행 플랜을 두세요.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '국비와 별도로 사비 EJU 병행 가능',
      mathCourseHint: '선발 시험·배치 대학 요건 따름',
      englishExternal: 'varies',
      hasPreArrivalHint: 'n/a',
      usesKyotsu: false,
      mextPath: true,
    },
    nextStepsByStage: {
      explore: [
        '주한일본대사관 해당 연도 학부 국비 공고 유무 확인',
        '대사관 추천 vs 대학 추천 차이 이해하기',
        '사비(EJU) 병행 여부 결정',
      ],
      prep: [
        '공고 원문의 일정·서류·시험 과목 표 만들기',
        '지망이유서·건강진단 등 서류 목록',
        '배치 희망 전공·대학 후보',
      ],
      apply: [
        '공고 마감·제출 형식 최종 확인',
        '사비 전형 병행 시 일정 충돌 점검',
        '결과 대기 중에도 요강 북마크 유지',
      ],
    },
    guideIds: ['mext-scholarship', 'mext-to-medicine', 'eju-vs-general'],
    resourceIds: [
      'embassy-kr-mext',
      'embassy-kr-mext-news',
      'studyinjapan-mext-undergrad',
      'mext-exam-past',
    ],
    exampleIds: ['embassy-mext', 'studyinjapan-mext', 'mext-exam-portal'],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'mext-medicine',
    tracks: ['mext'],
    fields: ['medicine'],
    stages: ['explore', 'prep', 'apply'],
    title: '국비(MEXT) → 의치약·보건',
    summary:
      '국비 학부 선발 후 배치·전공 제한이 있을 수 있습니다. 의계 지망은 공고·배치 조건을 원문으로 확인하세요.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '사비 의계 전형과 별개로 검토',
      mathCourseHint: '공고·배치 대학 요건',
      englishExternal: 'varies',
      hasPreArrivalHint: 'n/a',
      usesKyotsu: false,
      mextPath: true,
    },
    nextStepsByStage: {
      explore: [
        '학부 국비로 의계·보건 배치가 가능한지 공고·FAQ 확인',
        '사비 유학생/일반 의계 루트와 병행 여부',
        '대사관 공고 캘린더 확보',
      ],
      prep: [
        '공고 서류·시험 범위 정리',
        '전공 희망 기재 방식 확인',
        '건강·비자 관련 안내 위치',
      ],
      apply: [
        '제출 마감·형식 재확인',
        '의계 사비 요강과도 일정 대조',
        '결과 전 대안 루트 유지',
      ],
    },
    guideIds: ['mext-scholarship', 'mext-to-medicine', 'science-medicine-path'],
    resourceIds: [
      'embassy-kr-mext',
      'embassy-kr-mext-news',
      'studyinjapan-mext-undergrad',
      'mext-exam-past',
    ],
    exampleIds: ['embassy-mext', 'studyinjapan-mext', 'mext-exam-portal'],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
  {
    id: 'mext-humanities',
    tracks: ['mext'],
    fields: ['humanities'],
    stages: ['explore', 'prep', 'apply'],
    title: '국비(MEXT) → 문과·사회',
    summary:
      '국비 학부 문과 지망도 연도 공고가 기준입니다. 사비 EJU 문과 전형과의 일정 병행을 검토하세요.',
    facts: {
      needsEju: false,
      ejuSubjectsHint: '사비 EJU 문과와 병행 가능',
      mathCourseHint: '공고 요건',
      englishExternal: 'varies',
      hasPreArrivalHint: 'n/a',
      usesKyotsu: false,
      mextPath: true,
    },
    nextStepsByStage: {
      explore: [
        '대사관 학부 국비 공고 확인',
        '문과 배치·전공 기재 방식 조사',
        'EJU 문과 병행 여부',
      ],
      prep: [
        '서류·시험 일정 표',
        '지망이유서 초안',
        '사비 전형 요강 북마크',
      ],
      apply: [
        '공고 마감 준수',
        '사비 출원과 일정 충돌 점검',
        '결과 대기·대안',
      ],
    },
    guideIds: ['mext-scholarship', 'mext-to-medicine', 'eju-vs-general'],
    resourceIds: [
      'embassy-kr-mext',
      'embassy-kr-mext-news',
      'studyinjapan-mext-undergrad',
      'mext-exam-past',
    ],
    exampleIds: ['embassy-mext', 'studyinjapan-mext', 'mext-exam-portal'],
    updatedAt: '2026-08',
    disclaimer: commonDisclaimer,
  },
];

function stageDistance(a, b) {
  return Math.abs(STAGE_ORDER.indexOf(a) - STAGE_ORDER.indexOf(b));
}

/**
 * track×field×stage 매칭. stage 불일치 시 같은 track+field에서 가장 가까운 stage 폴백.
 */
export function matchRoutes(track, field, stage) {
  const exact = routeProfiles.filter(
    (r) =>
      r.tracks.includes(track) &&
      r.fields.includes(field) &&
      r.stages.includes(stage)
  );
  if (exact.length) {
    return exact.map((r) => ({ route: r, matchedStage: stage, fallback: false }));
  }

  const same = routeProfiles.filter(
    (r) => r.tracks.includes(track) && r.fields.includes(field)
  );
  if (!same.length) return [];

  return same.map((r) => {
    const nearest = [...r.stages].sort(
      (a, b) => stageDistance(a, stage) - stageDistance(b, stage)
    )[0];
    return { route: r, matchedStage: nearest, fallback: nearest !== stage };
  });
}

export function resourcesForProfile(route) {
  const ids = route.resourceIds || [];
  return ids.map((id) => officialResources.find((r) => r.id === id)).filter(Boolean);
}

export function examplesForProfile(route) {
  return examplesForIds(route.exampleIds || []);
}

export function factChips(facts = {}) {
  const chips = [];
  if (facts.needsEju === true) chips.push('EJU 활용');
  if (facts.needsEju === false && facts.usesKyotsu) chips.push('공통테스트');
  if (facts.usesKyotsu) chips.push('일반선발 축');
  if (facts.mextPath) chips.push('국비(MEXT)');
  if (facts.englishExternal === 'often') chips.push('영어 외부시험 잦음');
  if (facts.englishExternal === 'varies') chips.push('영어 요건 대학별');
  if (facts.hasPreArrivalHint === 'possible') chips.push('사전입학 가능성');
  if (facts.hasPreArrivalHint === 'rare') chips.push('사전입학 드묾');
  if (facts.mathCourseHint) chips.push(facts.mathCourseHint);
  return chips;
}
